import React from 'react';
import { Col } from 'react-bootstrap';

import styles from './styles.module.scss';
import cx from 'classnames';
import { SortOrder } from 'src/types/dealInsights';

interface TableHeaderProps {
    col: number;
    value: string;
    onClick: (val) => void;
    sortOrder?: SortOrder | '';
    sort: boolean;
}

const TableHeader: React.FC<TableHeaderProps> = ({ col, value, onClick, sort, sortOrder = 'asc' }) => {
    if (!value) {
        return <Col md={col} />;
    }
    return (
        <Col md={col}>
            <div className={cx(styles.header, {[styles.cursorPointer]: sort})} onClick={() => sort && onClick(sortOrder === 'asc' ? 'desc' : 'asc')}>
                <p className={styles.label}>{value}</p>

               { sort && <div className={cx(styles.sortIcons, { [styles.show]: sortOrder })}>
                    <i className={cx('paperflite-up-arrow', styles.sortIcon, {
                            [styles.active]: sortOrder === 'asc',
                        })}
                    />
                    <i className={cx('paperflite-dropdown', styles.sortIcon, {
                            [styles.active]: sortOrder === 'desc',
                        })}
                    />
                </div>}
            </div>
        </Col>
    );
};

export default TableHeader;
